import _defineProperty from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/workspaces/v_1/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["type", "message"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @template T
 * @param {import('../types').OutputError<T>} options
 */
const buildOutputError = _ref => {
  let {
      type,
      message
    } = _ref,
    payload = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread({
    type,
    message
  }, payload);
};

/** @type {typeof buildOutputError<import('../types').OutputFileErrorType>} */
export const buildOutputFileError = buildOutputError;

/** @type {typeof buildOutputError<import('../types').OutputCollectionErrorType>} */
export const buildCollectionFileError = buildOutputError;